import { render } from "./Panel.vue?vue&type=template&id=71c06b9c"
import script from "./Panel.vue?vue&type=script&lang=ts"
export * from "./Panel.vue?vue&type=script&lang=ts"

import "./Panel.vue?vue&type=style&index=0&id=71c06b9c&lang=less"
script.render = render

export default script